<template>
  <div class="item-warp" @click="shopDetails(item)">
    <div class="shop-item-top">
      <div class="shop-banner">
        <img
          alt=""
          :src="item.shopBanner || require('@/assets/imgs/banner-home.jpg')"
        />
        <!-- <div class="shop-status" :class="onlineStatus(item.infoStatus).class">
          {{ onlineStatus(item.infoStatus).text }}
        </div> -->
      </div>
      <div class="item-info">
        <div class="item-gourp">
          <span class="item-shopname">{{ item.shopName }}</span>
        </div>
        <div class="item-gourp">
          <img src="@/assets/imgs/shop/icon_shop_time.png" alt="" />
          <span class="address">{{ item.shopTime || "-" }}</span>
        </div>
        <div class="item-gourp">
          <img src="@/assets/imgs/shop/icon_shop_address.png" alt="" />
          <span class="address">{{ item.shopAddress1 }}</span>
        </div>
        <div class="item-gourp">
          <img src="@/assets/imgs/shop/icon_shop_cost.png" alt="" />
          <span v-if="extendedJson.remark">
            {{ extendedJson.remark }}
          </span>
          <span v-else>
            {{ item.currencyName }} {{ $moneyFormat(item.pjifei) }} /
            {{ item.pjifeiDanwei }}
            {{ $priceUnit(item.priceUnit) }}
          </span>
        </div>
      </div>
    </div>
    <div class="shop-item-bottom item-gourp">
      <!-- <div class="item-gourp-row">
        <img src="@/assets/imgs/shop/icon_shop_cabinet.png" alt="" />
        <span>{{ item.freeNum }} {{ i18n.shop_power_banks }}</span>
      </div>
      <div class="item-gourp-row">
        <img src="@/assets/imgs/shop/icon_charge_available.png" alt="" />
        <span
          >{{ parseInt(item.batteryNum - item.freeNum) }}
          {{ i18n.shop_empty_slots }}</span
        >
      </div> -->

      <div class="item-gourp-row battery" v-for="v in batteryInfo" :key="v">
        <div class="battery_num">
          <img :src="v.icon_path" class="battery_icon" alt="" />
          <span>{{ item[v.key] }}</span>
        </div>
        <span class="battery_lable"> {{ v.lable }}</span>
      </div>
    </div>
    <div class="shop-item-nav">
      <div class="item-gourp-near">
        <img src="@/assets/imgs/shop/icon_shop_nav.png" alt="" />{{
          item.distance
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const _shopT = this.$t("shop");
    return {
      error: "",
      loading: false,
      batteryInfo: [
        {
          lable: _shopT.fast_charging_power_banks,
          key: "fastChargeFreeNum",
          icon_path: require("@/assets/imgs/shop/icon_marker1.png"),
          icon_dark_path: require("@/assets/imgs/shop/icon_marker3.png")
        },
        {
          lable: _shopT.ordinary_power_bank,
          key: "ptChargeFreeNum",
          icon_path: require("@/assets/imgs/shop/icon_marker.png"),
          icon_dark_path: require("@/assets/imgs/shop/icon_marker2.png")
        },
        {
          lable: _shopT.returnable,
          key: "canReturnNum",
          icon_path: require("@/assets/imgs/shop/icon_return1.png"),
          icon_dark_path: require("@/assets/imgs/shop/icon_return2.png")
        }
      ]
    };
  },
  computed: {
    i18n() {
      return this.$t("shop");
    },
    extendedJson() {
      let extended = {};
      if (this.item && this.item.extendedJson) {
        extended = JSON.parse(this.item.extendedJson);
      }
      return extended;
    }
  },
  methods: {
    // 站点详情
    shopDetails(item) {
      this.$store.commit("shopInfo", item);
      this.$router.push(`/shop/details/${item.id}`);
    },
    // 获取状态
    onlineStatus(infoStatus) {
      return {
        text: this.$t(`map.${infoStatus}`),
        class: infoStatus === "在线" ? "online" : ""
      };
    }
  },
  created() {
    console.log(this.batteryInfo);
  }
};
</script>

<style lang="less" scoped>
.item-warp {
  position: relative;
  border-radius: 20px;
  margin-bottom: 42px;
  background: #fff;
  color: #000;
  border: 2px solid #d5d5d5;
  .shop-item-top {
    display: flex;
    padding: 48px 14px 14px;
    border-bottom: 2px solid #d5d5d5;
  }
  .shop-banner {
    width: 189px;
    height: 189px;
    position: relative;
    margin-right: 18px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 18px;
    }
  }
  .item-info {
    flex: 1;
  }
  .item-gourp {
    display: flex;
    align-items: center;
    margin: 4px 0;
    font-size: 22px;
    img {
      width: 36px;
      margin-right: 8px;
    }
    .item-shopname {
      color: #000;
      font-size: 32px;
    }
    .address {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shop-item-bottom {
    padding: 14px 10px;
    align-items: flex-start;
  }
  .battery {
    flex-flow: column;
    &_icon {
      margin: 0 !important;
      width: 58px;
    }
    &_lable {
      font-size: 20px;
    }
    &_num {
      flex: 1;
    }
  }

  .item-gourp-near {
    display: flex;
    align-items: center;
    margin-left: 24px;
    padding: 6px 20px;
    border-radius: 24px;
    background-color: #ebebeb;
    img {
      width: 26px;
    }
  }

  .item-gourp-row {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .shop-status {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 5px;
    border-radius: 0 0 18px 18px;
    background-color: #d5d5d5;
    text-align: center;
    &.online {
      background-color: #31b3ff;
      color: #fff;
    }
  }
  .shop-item-nav {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    color: #000;
  }
}
</style>
